<template>
  <div
    class="modal fade"
    tabindex="-1"
    id="add-category-modal"
    ref="newTargetModalRef"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered mw-950px">
      <div class="modal-content rounded">
        <BlockUI :loading="block" />
        <div class="modal-header">
          <h5 class="modal-title">{{ translate(title) }}</h5>

          <!--begin::Close-->
          <div
            class="btn btn-icon btn-sm btn-active-light-primary ms-2 text-dark"
            @click="closeModal"
            aria-label="Close"
          >
            <i class="bi bi-x-lg"></i>
          </div>
          <!--end::Close-->
        </div>

        <div class="modal-body rounded p-0">
          <Form
            v-slot="{ errors }"
            ref="refForm"
            id="example"
            class="form p-0 rounded-bottom"
            novalidate="novalidate"
            @submit="onSubmit"
            :validation-schema="categoryValidator"
            style="padding-bottom: 1.5rem !important; background: #fbfbfb"
          >
            <div>
              <div class="card-body">
                <div
                  class="tab-content"
                  id="myTabContent"
                >
                  <div
                    class="tab-pane fade show active"
                    id="kt_tab_pane_1"
                    role="tabpanel"
                  >
                    <div class="row mb-4">
                      <label class="col-lg-4 col-form-label required fw-bold fs-6">{{
                        translate("audit_categorys_modal_label_name")
                      }}</label>

                      <div class="col-lg-8 fv-row d-v-container">
                        <div class="fv-plugins-message-container d-v-content">
                          <div class="fv-help-block ms-2 v-element">
                            <ErrorMessage name="name" />
                          </div>
                        </div>
                        <Field
                          type="text"
                          name="name"
                          :class="`form-control form-control-lg fs-6 ${
                            errors['name'] !== undefined ? 'v-invalid' : ''
                          }`"
                          :placeholder="translate('audit_categorys_modal_label_name')"
                          v-model.trim="category.name"
                        />
                      </div>
                    </div>
                    <div class="row mb-4">
                      <label class="col-lg-4 col-form-label fw-bold fs-6">{{
                        translate("audit_categorys_modal_label_code")
                      }}</label>
                      <div class="col-lg-8 fv-row d-v-container">
                        <input
                          type="text"
                          name="code"
                          v-model="category.code"
                          :placeholder="translate('audit_categorys_modal_label_code')"
                          class="form-control form-control-lg fs-6"
                        />
                      </div>
                    </div>
                    <div class="row justify-content-end">
                      <div class="col-lg-8 fv-row">
                        <div class="form-check form-check-custom form-check-solid">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="check-remember"
                            v-model="category.published"
                          />
                          <div class="d-flex flex-column position-relative w-100">
                            <label
                              class="form-check-label col-form-label fw-bold p-0 mt-2"
                              for="check-remember"
                              style="margin-bottom: 15px"
                            >
                              {{ translate("customer_modal_check_label") }}
                            </label>
                            <label
                              class="form-check-label col-form-label fw-bold fs-7 p-0 text-gray-500"
                              for="check-remember"
                              style="position: absolute; margin-top: 20px"
                            >
                              {{
                                translate("audit_categorys_modal_check_label_description")
                              }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="d-flex justify-content-end ps-5 pe-5"
                style="padding-top: 1.5rem !important"
              >
                <button
                  @click="closeModal"
                  type="reset"
                  class="btn btn-white btn-active-light me-2 border btn-sm fs-6"
                >
                  {{ translate("Cancel") }}
                </button>

                <button
                  v-if="buttonShow"
                  type="submit"
                  id="kt_add_costumer_submit"
                  class="btn btn-primary border btn-sm fs-6"
                  :disabled="loading"
                >
                  <div
                    v-if="loading"
                    class="spinner-border spinner-border-sm mx-1"
                  ></div>
                  <span class="indicator-label">
                    {{ translate("Add") }}
                  </span>
                </button>
                <a
                  v-else
                  @click="updateItem"
                  class="btn btn-primary border btn-sm fs-6"
                  :class="errors['name'] !== undefined || loading ? 'disabled' : ''"
                >
                  <div
                    v-if="loading"
                    class="spinner-border spinner-border-sm mx-1"
                  ></div>
                  <span class="indicator-label">
                    {{ translate("Save") }}
                  </span>
                </a>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ErrorMessage, Field, Form } from "vee-validate";
import { hideModal } from "@/core/helpers/dom";
import { ref, computed, reactive, onMounted, defineProps, defineEmits, watch } from "vue";
import * as Yup from "yup";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

// Props and Emits

const props = defineProps({ categoryItem: Number });
const emits = defineEmits(["closeModal"]);
const block = ref(false);
const loading = ref(false);

watch(props, () => {
  if (props.categoryItem !== null) {
    block.value = true;
    buttonShow.value = false;
    store
      .dispatch("AdminTemplateCategoryModule/GET_CATEGORY", props.categoryItem)
      .then((response) => {
        title.value = response.Name;
        category.name = response.Name;
        category.code = response.Code;
        category.Id = response.Id;
        category.published = response.Published;
      })
      .finally(() => (block.value = false));
  }
});

//Store Tanımlaması
const store = useStore();

// Multi Language
const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

// Validation Tanımlaması
const categoryValidator = Yup.object().shape({
  name: Yup.string()
    .nullable()
    .required(translate("audit_audit_categorys_validation_name")),
});

const newTargetModalRef = ref(null);
const refForm = ref(null);
const title = ref("audit_categorys_button_add_category");
const buttonShow = ref(true);
const tabsLink = ref("Standart");

//Category
const category = reactive({
  Id: 0,
  name: null,
  code: null,
  published: true,
});

// Submit İşlemleri
const onSubmit = () => {
  loading.value = true;
  store
    .dispatch("AdminTemplateCategoryModule/ADD_CATEGORY", category)
    .then((response) => {
      loading.value = false;
    });
  closeModal();
};

// Update Item
const updateItem = () => {
  loading.value = true;
  store
    .dispatch("AdminTemplateCategoryModule/UPDATE_CATEGORY", category)
    .then((response) => {
      loading.value = false;
    });
  closeModal();
};

// Modal Close
const closeModal = () => {
  hideModal(newTargetModalRef.value);
};

const clearForm = () => {
  setTimeout(() => {
    title.value = "audit_categorys_button_add_category";
    category.Id = 0;
    category.code = null;
    category.name = null;
    category.published = true;
    buttonShow.value = true;
    refForm.value.resetForm();
    emits("closeModal");
  }, 300);
};

onMounted(() => {
  document
    .getElementById("add-category-modal")
    .addEventListener("hide.bs.modal", function () {
      clearForm();
    });
});
</script>

<style></style>
